export default "__VITE_ASSET__f524df1b__"